export default {
    data: {},
    chatId: 'a8g2DkK6',
    alexChatModal: false,
    trainingItemList: [],
    testItemList: [],
    userSegments: []
}
